import {
  BotCampaignCreateDTO,
  BotCampaignDraftContext,
  BotCampaignDraftContextRequest,
  BotCampaignFireRequest,
  BotCampaignFireResult,
  BotCampaignInterface,
  BotCampaignRecipientInterface,
  BotCampaignStarterOption,
  BotCampaignSummary
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

/**
 * SMS campaigns on the Snowy bot (ENG-3114). Studio talks to the server; the Bull fan-out
 * worker talks to the bot. Separate from the legacy `Campaign.API` (quest broadcasts).
 */
export class SnowyCampaignsAPI {
  static async listStarters(orgId: number) {
    return APIService.Server.get<BotCampaignStarterOption[]>(`/snowy-campaigns/org/${orgId}/starters`);
  }

  static async create(orgId: number, dto: BotCampaignCreateDTO) {
    return APIService.Server.post<BotCampaignInterface>(`/snowy-campaigns/org/${orgId}`, dto);
  }

  static async list(orgId: number, params?: { after?: number; limit?: number }) {
    return APIService.Server.get<BotCampaignSummary[]>(`/snowy-campaigns/org/${orgId}`, params);
  }

  static async recipients(orgId: number, campaignId: number) {
    return APIService.Server.get<BotCampaignRecipientInterface[]>(`/snowy-campaigns/org/${orgId}/campaign/${campaignId}/recipients`);
  }

  static async recipientsByUser(orgId: number, userId: number) {
    return APIService.Server.get<BotCampaignRecipientInterface[]>(`/snowy-campaigns/org/${orgId}/user/${userId}/recipients`);
  }

  /** Bull → bot: fire one recipient (internal auth). */
  static async fireRecipient(request: BotCampaignFireRequest) {
    return APIService.Bot.post<BotCampaignFireResult>("/starters/fire", request);
  }

  /**
   * Ask the bot to turn an agent's written campaign message into a priming context and a
   * plain-language summary to confirm (ENG-3114). One call per campaign, at compose time.
   */
  static async draftContext(request: BotCampaignDraftContextRequest): Promise<BotCampaignDraftContext | null> {
    return APIService.Bot.post<BotCampaignDraftContext | null>("/starters/draft-context", request);
  }

  /**
   * Studio → server: read a written campaign message back in plain language before it is sent.
   * The server forwards to the bot, which owns the model call.
   */
  static async draftContextForOrg(orgId: number, request: BotCampaignDraftContextRequest): Promise<BotCampaignDraftContext | null> {
    return APIService.Server.post<BotCampaignDraftContext | null>(`/snowy-campaigns/org/${orgId}/draft-context`, request);
  }
}
